







































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import createdata from '@/store/entities/create-order'
import CreateOrderProductInfo from '@/store/entities/create-order-product'
import warehouseCity from '@/store/entities/warehouse-city';
import warehouseInfo from '@/store/entities/warehouseInfo';
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'


@Component({
   
})
export default class EditOrder extends AbpBase {
    createrequest: createdata = new createdata();
    warehouseCityList: Array<warehouseCity> = [];
    warehouseInfoList: Array<warehouseInfo> = [];
    warehouseCityId: number = 0;
    cargoCategoryType = Enums.CargoCategoryType;
    siteType = Enums.SiteSType;
    addLoding = false;
    loadpdfLoding = false;
    orderStatus: number;
    isEdit = false;
    isShow = false;
    pdfInfo: string = '';
    pdfUrl: string = '';
    isDisplay:string='';
    isReadonly = '';
    isDisplayGetPdf: string = "";
    headers: any = {
        "Authorization": "Bearer " + window.abp.auth.getToken(),
        ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
        "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
    };
    ruleInline = {
        warehouseInfoId: [
            { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
        ],
        orderNumber: [
            { required: true, min: 6, max: 200, message: '虾皮订单编号不能为空，且长度必须大于6且小于200', trigger: 'blur' }
        ],
        shippingMethods: [
            { max: 100, message: '长度不能大于100', trigger: 'blur' }
        ],
        reMark: [
            { max: 500, message: '长度不能大于500', trigger: 'blur' }
        ]
    };

    async changeWarehouseCity(val: number) {
        this.warehouseInfoList = await this.$store.dispatch({
            type: 'warehouseInfo/get',
            data: { CityId: val }
        });
        if (this.warehouseInfoList.length == 1) {
            this.createrequest.warehouseInfoId = this.warehouseInfoList[0].id;
        }
    }

    async returnBack() {
        this.backPage();
    }
    async getCity() {
        this.warehouseCityList = await this.$store.dispatch({
            type: 'warehouseCity/get',
            data: {}
        });
        if (this.warehouseCityList.length > 0) {
            this.warehouseCityId = this.warehouseCityList[0].id;
            this.changeWarehouseCity(this.warehouseCityId);
        }
    }

    handleSuccess(res, file) {
        if (res.success) {
            this.createrequest.pdfGuid = res.result;
            this.pdfInfo = "双击查看";
        }
    }

    async ViewPdf() {
        if (this.createrequest.pdfGuid && this.createrequest.pdfGuid.length > 0) {
            window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + this.createrequest.pdfGuid + "&id=" + abp.session.userId);
        }
    }

    handleError(res, file) {
        this.$Message.error('上传PDF失败。');
    }

    async created() {
        await this.getCity();
        this.createrequest = this.$store.state.fontorder.orderInfo;
        this.orderStatus = this.$store.state.fontorder.orderStatus;
        console.log(this.createrequest.orderType);
        //if (this.createrequest.orderType == 1) {
        //    this.isShow = true;
        //}
        if ((this.createrequest.orderStatus == 0 && this.createrequest.packageStatus == 0) || this.createrequest.orderStatus==-1) {
            this.isDisplay = "";
            this.isDisplayGetPdf = "none";
            this.isEdit=true;
        }
        else if (this.createrequest.orderStatus == 3)
        {
            this.isEdit = true;   
        }
        else {
            this.isDisplay="none";
            this.isReadonly = 'readonly';
            this.isDisplayGetPdf = "none";
            this.isEdit=false;
        }
        
        this.pdfInfo = this.createrequest.pdfGuid ? "双击查看" : "未上传";
        this.pdfUrl = appconst.remoteServiceBaseUrl + "api/services/app/FrontOrder/UploadOrderPdf";

    }

    async getpdf() {
        this.loadpdfLoding = true;
        var responsedata = await this.$store.dispatch({
            type: 'authorizationShop/DwonLoadPdf',
            data: { orderNumber: this.createrequest.orderNumber }
        }).finally(() => {
            this.loadpdfLoding = false;
        }); 
        this.pdfInfo = "双击查看";
        this.createrequest.pdfGuid = responsedata.pdfGuid;
        //this.createrequest.orderLogisticsNumber = responsedata.trackingNumber;
        if (!this.createrequest.pdfGuid || this.createrequest.pdfGuid.length < 1) {
            this.$Message.error('pdf获取失败。');
            return;
        }
    }
    async add(number) {
        (this.$refs.createform as any).validate(async (valid: boolean) => {
            if (valid) {
                if (!this.createrequest.pdfGuid || this.createrequest.pdfGuid.length < 1) {
                    this.$Message.error('请上传pdf。');
                    return;
                }
                if (this.createrequest.expressDelivery.length == 0) {
                    this.$Message.error('请添加物流单号。');
                    return;
                }
                if (this.createrequest.orderProductInfo.length == 0) {
                    this.$Message.error('请添加商品。');
                    return;
                }
                this.addLoding = true;
                await this.$store.dispatch({
                    type: 'fontorder/updateOrder',
                    data: this.createrequest
                }).finally(() => {
                    this.addLoding = false;
                });
                if (number == 1) {
                    this.$Message.success('修改成功。');
                }
                else {
                    this.$Message.success('订单信息补充成功。');
                }
               
            }
        })
    }
    expressDeliveryAdd() {
        this.createrequest.expressDelivery.push('');
    }
    expressDeliveryRemove(index) {
        this.createrequest.expressDelivery.splice(index, 1);
    }
    productAdd() {
        this.createrequest.orderProductInfo.push(new CreateOrderProductInfo());
    }
    productRemove(index) {
        this.createrequest.orderProductInfo.splice(index, 1);
    }

    isEmpty(rule, value, callback) {
        if (value == null || value == undefined || value == "") {
            callback(new Error('价格不能为空！'))
        } else {
            callback();
        }
    }
    isDisable(){
       return this.isEdit;
    }
    
}
